import "./Lib/GridOverlay";

// Core
import { mount } from "./Lib/registry";

// Shared shell components
import "./Components/Atoms/Button/Button";
import "./Components/Atoms/Link/Link";
import "./Components/Atoms/BackToTop/BackToTop";
import { initFormTracking } from "./Lib/formTracking";

// Quick Fixes
import { initQuickFixes } from "./Lib/WCAG/quick-fixes";

function init() {
  initFormTracking("[data-form-id]");
  initQuickFixes();
}

init();

document.addEventListener("DOMContentLoaded", () => {
  mount(document);
});

history.scrollRestoration = "manual";
window.scrollTo({ top: 0, left: 0, behavior: "instant" });

const mainEl = document.querySelector<HTMLElement>("main");
const prefersReducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)"
);

if (mainEl?.dataset.reloadToTop === "1" && !prefersReducedMotion.matches) {
  const BREAKPOINTS = [480, 768, 1024, 1280, 1440, 1920];
  const getBreakpoint = () =>
    BREAKPOINTS.findIndex((bp) => window.innerWidth < bp);

  let currentBreakpoint = getBreakpoint();
  let debounce: ReturnType<typeof setTimeout>;

  window.addEventListener(
    "resize",
    () => {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        if (getBreakpoint() !== currentBreakpoint) {
          window.location.reload();
        }
      }, 150);
    },
    { passive: true }
  );
}
